import { render, staticRenderFns } from "./TermsAndConditionsView.vue?vue&type=template&id=1206d3ae&scoped=true"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsView.vue?vue&type=style&index=0&id=1206d3ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206d3ae",
  null
  
)

export default component.exports